import { GenericActionWithPayload } from "./action-types";
import { Order } from "./order";

type SetPrinterHostAction = GenericActionWithPayload<
  "SET_PRINTER_HOST",
  string
>;

type SetPrinterUrlAction = GenericActionWithPayload<"SET_PRINTER_URL", string>;

type PrintReceiptAsyncAction = GenericActionWithPayload<
  "PRINT_RECEIPT_ASYNC",
  Order
>;

type PrinterAction = SetPrinterHostAction | SetPrinterUrlAction;

export {
  PrinterAction,
  SetPrinterHostAction,
  SetPrinterUrlAction,
  PrintReceiptAsyncAction,
};
